import api from '../api/client';

/** Saved per-provider settings ({ configs, fields }) for an app. Secrets are never returned. */
const getEmailConfig = async (appId) => {
    const res = await api.get('/api/application/email-config', { params: { app_id: appId } });
    return res?.data?.data || { configs: {}, fields: {} };
};

/** Save one provider's settings; blank secrets keep the stored ones. */
const saveEmailConfig = async (appId, provider, settings, secrets) => {
    const res = await api.post('/api/application/email-config', { app_id: appId, provider, settings, secrets });
    return res?.data;
};

const emailConfigService = { getEmailConfig, saveEmailConfig };
export default emailConfigService;
